import { FC, useRef } from 'react';
import { Popup, Form, Selector, Button, FormInstance, Input, Field, Toast } from 'react-vant';

interface SelectHouseTagProps {
  visible: boolean;
  onClose: () => void;
  onSuccessSearch: (values: any) => void;
}

const SearchPopus: FC<SelectHouseTagProps> = (props) => {
  const { visible, onClose, onSuccessSearch } = props;
  const [form] = Form.useForm();
  const formRef = useRef<FormInstance>(null);
  

  const handleSubmit = () => {
    formRef.current?.validateFields()
      .then(values => {
        Toast.success('提交成功');
        console.log('表单数据:', values);
        // API调用等操作...
        const data = {...values}
        data.rentTypes = data.rentTypes && data.rentTypes.length ? data.rentTypes.join(',') : ''
        onSuccessSearch(data)
      })
      .catch(() => {
        Toast.fail('请填写完整信息');
      });
  };

  // 重置表单
  const handleReset = () => {
    formRef.current?.resetFields();
    Toast.info('查询条件已重置');
  };

  return (
    <Popup
      visible={visible}
      onClose={onClose}
      position={'top'}
      style={{ height: '50%', width: '100%',    'border-bottom-right-radius': '10px',
       'border-bottom-left-radius': '10px' }}
    >
      <Form
        layout={'vertical'}
        ref={formRef}
        form={form}
      >
        <Form.Item label={'租赁方式'} name={'rentTypes'} >
          <Selector 
              options={[
                { label: '整租', value: '整租' },
                { label: '合租', value: '合租' },
                { label: '出售', value: '出售' },
                { label: '求租', value: '求租' },
                { label: '求购', value: '求购' },
              ]}
              multiple 
            />
        </Form.Item>
    
        <Field label="租赁面积" style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <Form.Item  name="minArea" >
            <Input
              type='number'
              placeholder='最小面积'
            />
            </Form.Item >
            ~
            <Form.Item  name="maxArea" >
            <Input
              type='number'
              placeholder='最大面积'
            />
            </Form.Item >
          </div>
        </Field>
        <Field label="价格" style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <Form.Item  name="minPrice" >
            <Input
              type='number'
              placeholder='最低价格'
            />
            </Form.Item >
            ~
            <Form.Item  name="maxPrice" >
            <Input
              type='number'
              placeholder='最高价格'
            />
            </Form.Item >
          </div>
        </Field>
        <div style={{ margin: '36px 6px', display: 'flex', 'justifyContent': 'center' }}>
            
            <Button 
              onClick={handleReset}
              block
              style={{ 'marginRight': '16px' }}
              round
            >
              重置
            </Button>
            <Button 
              type="primary" 
              onClick={handleSubmit}
              block
              round
            >
              确定
            </Button>
      </div>
      </Form>
      
    </Popup>
  );
};

export default SearchPopus;
